import Box from '@zenbusiness/zui/Box';
import Skeleton from '@zenbusiness/zui/Skeleton';
import useMediaQuery from '@zenbusiness/zui/useMediaQuery';

import * as Styled from './RegistrationCard.styles';

function RegistrationCardSkeleton() {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

  return (
    <Styled.CardWrapper>
      <Skeleton
        variant="rectangular"
        width={isMobile ? '100%' : '50%'}
        height={isMobile ? '10rem' : '12rem'}
      />
      <Styled.ContentWrapper>
        <Box>
          <Skeleton width="80%" height="1.5rem" sx={{ mb: 1 }} />
          <Skeleton width="100%" height="1rem" sx={{ mb: 0.5 }} />
          <Skeleton width="70%" height="1rem" />
        </Box>
        <Skeleton
          width={isMobile ? '40%' : '30%'}
          height="2.5rem"
          sx={{ mt: 'auto' }}
        />
      </Styled.ContentWrapper>
    </Styled.CardWrapper>
  );
}

export default RegistrationCardSkeleton;
